import { render, staticRenderFns } from "./EstablishmentContact.vue?vue&type=template&id=39bdf664&scoped=true"
import script from "./EstablishmentContact.vue?vue&type=script&lang=js"
export * from "./EstablishmentContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bdf664",
  null
  
)

export default component.exports